<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules">
          <div>司机信息</div>
          <div class="left-box">
            <div class="center-box-1">
              <span class="center-name"
                    v-for="(item, index) in selectRows" :key="index">{{ item.username }} </span>
            </div>

          </div>
          <el-form-item prop="dispatchDeptId" label="分配调度组">
            <el-select
              style="width: 100%"
              v-model="form.dispatchDeptId"
              filterable
              @change="handleChange"
              placeholder="请选择"
            >
              <el-option
                v-for="item in deptData"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="dispatcherId"
            label="分配责任调度"
          >
            <el-select
              style="width: 100%"
              v-model="form.dispatcherId"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in peopleData"
                :key="item.userId"
                :label="item.username+'('+item.deptName+')'"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { batchDispatcher, fenDept, fenDispatcher, schedulingDriver } from "./api";
import { getDispatchDeptForUser } from "@/views/commonApi";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "批量分配调度",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      carImage: require("@/assets/imgs/title.png"),
      form: {
        dispatchDeptId: "",
        driverId: "",
        dispatcherId: "",
      },
      rules: {
        dispatchDeptId: [{ required: true, message: "调度组不能为空" }],
        dispatcherId: [{ required: true, message: "责任调度不能为空" }],
      },
      type: null,
      deptData: [], // 调度组数据
      selectRows: [], // 需要被调度的司机
      peopleData: [], // 调度组 人员数据
    };
  },
  watch: {
    "form.dispatchDeptId": function (val) {
      if (val) {
        this.getPeople(val);
      } else {
        this.peopleData = []
      }

    },
  },
  mounted() {},
  methods: {
    init(selectRows, deptData) {
      this.deptData = deptData;
      this.selectRows = selectRows;
      this.dialogObj.show = true;
    },
    handleChange() {
      this.form.dispatcherId = ""
    },
    getPeople(val) {
      getDispatchDeptForUser(val).then((res) => {
        if (res.code === 200) {
          this.peopleData = res.data;
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let driverIds = []
          this.selectRows.forEach((item) => {
            driverIds.push(item.driverId);
          })
          let params = {
            deptId: this.form.dispatchDeptId,
            dispatcherId: this.form.dispatcherId,
            driverIds: driverIds,
          };
          batchDispatcher(params)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("分配成功");
                this.$parent.handleChangeOtherThing()
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
    padding: 0.2rem 0;
    .center-name{
      margin-right: 0.1rem;
    }
  }
}
</style>
